import * as auth from './auth'
import * as resource from '../vuex/resource'
/* eslint-disable prefer-rest-params*/
/* eslint-disable no-undef */
/* eslint-disable wrap-iife */

const ticketGroupToken = 'b9e39f22b2f985eef71c64e064716741' // 票务客服组
const travelGroupToken = 'a7ecd2ac5c3c612dbd66b0b3e65f68d3' // 旅游客服组

// 新版美洽工作台(平台版)的企业ID，旧企业ID 51040 的旧版插件已废弃
const MEIQIA_ENT_ID = '908a77fe473507ef42b19f5215569e9e'

// 插件是否初始化完成。showPanel 在初始化完成前调用会被插件丢弃
let isWidgetReady = false

// 插件脚本加载失败(被华为/小米等浏览器拦截等)时置为 true，改用聊天链接兜底
let isWidgetBroken = false
let fallbackTimer = null

// 插件不可用时的兜底：跳转美洽聊天链接独立页
function openChatPage() {
  window.location.href = `https://visitor-static.meiqia.com/fe-widget-visitor/standalone.html?eid=${MEIQIA_ENT_ID}`
}

// 打开聊天窗。插件未初始化完成时挂到 allSet 回调上，等初始化完成后再打开
function showPanel() {
  if (isWidgetBroken) {
    openChatPage()
    return
  }
  if (typeof _MEIQIA !== 'function') {
    return
  }
  if (isWidgetReady) {
    _MEIQIA('showPanel')
    return
  }
  _MEIQIA('allSet', () => {
    isWidgetReady = true
    _MEIQIA('showPanel')
  })
  // 迟迟未初始化成功则视为插件不可用(部分浏览器静默拦截插件脚本)，后续点击改走聊天链接
  if (!fallbackTimer) {
    fallbackTimer = setTimeout(() => {
      if (!isWidgetReady) {
        isWidgetBroken = true
      }
    }, 5000)
  }
}

function insertRedPoint(parentId, unreadNum) {
  const span = document.createElement('div')
  span.className = 'red-point'
  if (parentId === 'unread') {
    span.innerHTML = unreadNum
    document.getElementById(parentId)
      .getElementsByTagName('p')[0].getElementsByClassName('vux-label')[0].appendChild(span)
    return
  }
  document.getElementById(parentId).appendChild(span)
}

function setDomHtml(route, className, unreadNum) {
  /* eslint-disable no-plusplus */
  const elem = document.getElementsByClassName(className)
  if (unreadNum !== 0) {
    // Insert red point if dom does not exist
    if (elem.length === 0) {
      if (route === 'match-detail' || route === 'route-detail') {
        insertRedPoint('custom-service', unreadNum)
      } else {
        insertRedPoint('unread', unreadNum)
        insertRedPoint('user-tab', unreadNum)
      }
    } else {
      const unreadEl = document.getElementById('unread')
      if (unreadEl) {
        unreadEl.innerHTML = unreadNum
      }
    }
    return
  }
  const len = elem.length
  if (len !== 0) {
    // remove dom if unread num is 0
    for (let i = 0; i < len; i++) {
      elem[0].remove()
    }
  }
}

function getDomHtml(className) {
  const elem = document.getElementsByClassName(className)
    && document.getElementsByClassName(className)[0]
  return !!elem && elem.innerHTML
}

function setClientInfo(user) {
  function setUser(pbuser) {
    clientId = pbuser.uid
    clientInfo = {
      name: pbuser.name,
      avatar: pbuser.avatar,
      gender: pbuser.gender ? '男' : '女',
      tel: pbuser.mobile,
    }
  }
  if (auth.isLoggedIn()) {
    if (!user) {
      const jwt = auth.getUser()
      resource.user.get({ id: jwt.userId })
        .then(res => res.json())
        .then((data) => {
          setUser(data)
        })
    } else {
      setUser(user)
      _MEIQIA('clientId', clientId)
      _MEIQIA('metadata', clientInfo)
    }
  } else {
    // Logout Flow
    clientInfo = {
      name: '访客',
    }
    clientId = auth.getUUID()
    _MEIQIA('clientId', clientId)
    _MEIQIA('metadata', clientInfo)
  }
}

function getUnreadNum(route) {
  _MEIQIA('getUnreadMsg', (msg) => {
    let num = 0
    if (Array.isArray(msg) || typeof (msg) === 'object') {
      let unreadNum
      if (route === 'match-detail' || route === 'route-detail') {
        unreadNum = +document.getElementById('custom-service').innerHTML
      } else {
        unreadNum = +getDomHtml('red-point')
      }
      num = unreadNum + msg.length
    } else if (msg === 'hasBeenRead') {
      num = 0
    }
    setDomHtml(route, 'red-point', num)
  })
}

function load(m, ei, q, i, a, j, s) {
  m[i] = m[i] || function lmb() {
    (m[i].a = m[i].a || []).push(arguments)
  }
  j = ei.createElement(q)
  s = ei.getElementsByTagName(q)[0]
  j.async = true
  j.charset = 'UTF-8'
  j.src = 'https://visitor-static.meiqia.com/fe-widget-visitor/loader.js'
  j.onerror = () => {
    isWidgetBroken = true
  }
  s.parentNode.insertBefore(j, s)
}

function setup(route, groupToken) {
  _MEIQIA('entId', MEIQIA_ENT_ID)
  // resource.HTTP.get('/api/config').then(res => res.json())
  //   .then((config) => {
  //     _MEIQIA('assign', {
  //       groupToken: config.meiqiaGroupToken,
  //     })
  // 默认是票务部客服
  if (groupToken) {
    _MEIQIA('assign', { groupToken })
  } else {
    _MEIQIA('assign', { groupToken: ticketGroupToken })
  }

  getUnreadNum(route)
  _MEIQIA('withoutBtn')
  // 初始化成功回调必须在 init 之前注册
  _MEIQIA('allSet', () => {
    isWidgetReady = true
  })
  _MEIQIA('init')
  // })
}

function init(route, groupToken) {
  load(window, document, 'script', '_MEIQIA')
  _MEIQIA('manualInit')
  setup(route, groupToken)
}

export default {
  init,
  setup,
  showPanel,
  setClientInfo,
  ticketGroupToken,
  travelGroupToken,
}



// WEBPACK FOOTER //
// ./client/utils/meiqia.js